var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDreamio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#393C42;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#55BFCE;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#25ABAD;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 6 191.999995)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.8,190.7c-0.5,0.6-1.8,0.6-3.5-0.2l-20.8-10.6c0,0-0.1,0.1-0.1,0.1c-0.4,0.4-0.7,0.7-1.1,1.1 c-0.6,0.5-1.7,1.2-2.4,1.5c-4.5,2.3-9.8,2.1-14.5,0.7c-5.3-1.6-10.3-4.8-14.1-8.8c-1.7-1.8-3.2-3.9-4.4-6.1 c-1.5-2.8-2.4-5.8-2.7-8.9c-0.5-6.1,1.2-14,5.4-18.6c1-1.2,2.1-2.2,3.2-3.3c0.8-0.8,1.7-1.6,2.5-2.5c1.5-1.8,2.3-3.6,3-5.9 l0.1-0.3l0.3,0.2c4.3,3.1,5.9,7.2,2.8,11.8c1.8,1.5,2.7,3.6,2.7,5.9c0,2.2-0.9,4.6-2.8,5.9c0.8,0.3,2,0.9,2.8,1.2 c0-0.7-0.6-1.8-0.1-2.1c1-0.6,4.8,1,6.1,4.4c1.2,0.4,1.9,0.7,3.2,1.2c4.9,2,10.3,4.8,13.3,8.3c1,1.2,3.1,4.7,0.8,5.6 c0.8,0.9,1.3,2.4,1,3.4l17.8,13C57.6,188.5,58.4,190,57.8,190.7z M3.1,146.4c-0.4,2.2,3.4,4.1,5.4,5C8,149.8,7,148.2,5.8,147 C5.2,146.5,3.7,145.1,3.1,146.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.5,168.3c1.3,1.7,0.4,2.7-0.5,1.7c-1.8-1.9-4.6-2.5-7.1-2.1c-3.7,0.6-3.8,1.2-3.2,1.7 c4.3-1.6,9.3,0.5,11.4,3.9c0.9,1.3-2.1,2.3-3.9,4.7c-8.5,11.5-35.3,1.5-37.8-18.7c-0.8-6.1,0.9-12.8,5.1-17.5 c3.1-3.5,6.5-5,8.4-10.6c3.7,3.2,3.2,6.8,0.4,10c4.7,2.4,4,8.7,0.7,10.7c-1.5-5.6-7-9.8-8.3-5.8c-0.8,4.1,5.9,6.8,16.6,10.8 C27.3,160.6,33.1,163.4,36.5,168.3L36.5,168.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M36.5,168.3c1.3,1.7,0.4,2.7-0.5,1.7c-1.6-1.6-3.9-2.3-6.1-2.2c-3.7,0.3-6.6,1-9.3,0.7 c-5.3-0.5-10.5-3.9-13.3-6.7c-4.7-4.8-9.8-14.8-4.6-16.7c-0.4,0.2-0.7,0.7-0.9,1.3c-0.8,4.1,5.9,6.8,16.6,10.8 C27.3,160.6,33.1,163.4,36.5,168.3L36.5,168.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.5,160.5c2.8-1.3,2.2-6.1,1.8-7.3c5.2,1.5,3.7,9.2,6.1,11.6C18.4,164.9,12.7,161.9,13.5,160.5L13.5,160.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.4,174.5c0.7,0.4,1.7,0.1,2.1-0.6c0.4-0.7,0.1-1.6-0.6-2.1c-0.7-0.4-1.7-0.1-2.1,0.6 C21.4,173.2,21.7,174.1,22.4,174.5L22.4,174.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.1,173.9l21,14.6c0.6,0.4,1.4,1.3,1,1.8c-0.3,0.4-1.2,0.2-2-0.2l-22.7-12.3 C31.7,176.3,33.2,173.1,35.1,173.9L35.1,173.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33.3,176.8l21.9,12.9c1,0.6,1.3,0.6,1.9,0.6c-0.3,0.4-1.2,0.1-2-0.2l-22.7-12.3c-0.6-1.2,0.2-3.3,1.4-3.9 C33.4,174.9,33.1,175.9,33.3,176.8L33.3,176.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M0.9,171c0.7,0.1,1.3-0.4,1.3-1.1c0-0.7-0.6-1.4-1.3-1.5c-0.7-0.1-1.3,0.4-1.2,1.1 C-0.4,170.2,0.2,170.9,0.9,171L0.9,171z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M5.2,175.7c0.6,0.1,1.1-0.3,1.1-1c0-0.7-0.5-1.3-1.2-1.4c-0.6-0.1-1.1,0.3-1.1,1C4,175,4.6,175.6,5.2,175.7 L5.2,175.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M18.1,181.9c0.6,0,1-0.6,0.9-1.2c-0.2-0.6-0.8-1.1-1.4-1.1c-0.6,0-1,0.6-0.9,1.2 C16.8,181.5,17.4,182,18.1,181.9L18.1,181.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M22,182.6c0.5-0.1,0.8-0.6,0.6-1.1c-0.2-0.5-0.8-0.8-1.3-0.7c-0.5,0.1-0.8,0.6-0.6,1.1 C20.9,182.4,21.5,182.7,22,182.6L22,182.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M5.2,172.8c0.5,0.1,0.8-0.3,0.8-0.7c0-0.5-0.4-0.9-0.9-1c-0.5-0.1-0.8,0.2-0.8,0.7 C4.4,172.2,4.8,172.7,5.2,172.8L5.2,172.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-1.4,167.3c0.5,0.1,0.9-0.3,0.9-0.8c0-0.5-0.4-1-0.9-1.1c-0.5-0.1-0.9,0.3-0.9,0.7 C-2.3,166.7-1.9,167.2-1.4,167.3L-1.4,167.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M37.9,179.5c-0.1,0.5-0.1,0.9-0.1,1.3l-1-0.5c0-0.4,0.1-0.8,0.3-1.2c0.4-1.1,1.2-2.1,1.8-2.3 C38.5,177.5,38.1,178.5,37.9,179.5z M43.1,182.6c0,0.4-0.1,0.7,0,1l-0.8-0.5c0-0.3,0.1-0.6,0.2-0.9c0.4-1,1.1-1.9,1.5-1.9 C43.6,180.7,43.3,181.7,43.1,182.6z M48.3,185.6L48.3,185.6c0,0.3-0.1,0.5,0,0.8l-0.7-0.4c0-0.2,0-0.5,0.1-0.7v0 c0.2-0.7,0.6-1.4,1.2-1.5C48.7,184.2,48.4,184.8,48.3,185.6z M53.3,188.5c0,0.2-0.1,0.4,0,0.5v0l-0.4-0.2l-0.2-0.1 c0-0.1,0.1-0.3,0.2-0.5c0.2-0.5,0.6-1.1,0.9-1.3C53.6,187.3,53.4,187.9,53.3,188.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDreamio);
export default __webpack_public_path__ + "static/media/dreamio.b49b10123a480074436c7822a1699bb3.svg";
export { ForwardRef as ReactComponent };